module.exports = __webpack_public_path__ + "img/bannermini.b695aa91.png";